module.exports = __webpack_public_path__ + "static/media/Status_Completed.b88fc462.svg";